import { MatComponentsModule } from '../../mat-components.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppBodyComponent } from './app-body/app-body.component';
import { AppFooterComponent } from './app-footer/app-footer.component';
import { AppHeaderComponent } from './app-header/app-header.component';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { RouterModule } from '@angular/router';
// import { UserMenuComponent } from '../dashboard/user-menu/user-menu.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserMenuComponent } from '../dashboard/user-menu/user-menu.component';
import { MaintenanceBannerComponent } from '../shared/maintenance-banner/maintenance-banner.component';

@NgModule({
  declarations: [
    AppBodyComponent,
    AppFooterComponent,
    AppHeaderComponent,
    DefaultLayoutComponent,
    UserMenuComponent,
    MaintenanceBannerComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    MatComponentsModule
  ],
  exports:[
    DefaultLayoutComponent,
    AppBodyComponent,
    AppFooterComponent,
    AppHeaderComponent
  ],
    schemas:[CUSTOM_ELEMENTS_SCHEMA]
  
})
export class AppLayoutModule { }
